import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import UseFullPageLoader from "../FullPageLoader/UseFullPageLoader";

const About = () => {
    document.title = "DirtMap - About";
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [page, setCmsPage] = useState([]);
    const [loader, showLoader, hideLoader] = UseFullPageLoader();

    useEffect(() => {
        showLoader();
       let isMounted  = true;
        axios.post(`api/cms/page/about`).then(res => {
            console.log(res.data.result);
            if(isMounted) {
                if (res.data.result) {
                    hideLoader();
                    setCmsPage(res.data.result);
                    setLoading(false);
                } else if (res.data.status === 'false') {
                    hideLoader();
                    history.push('/');
                    swal("warning", res.data.message, "error");
                }
            }
        });
        return () => {
            isMounted = false;
            hideLoader();
        };
    }, [history]);

    if(loading  ) {
        return <div className="fp-container"><img src={"/images/spinner.gif"} className="fp-loader" alt="loading" /></div>;
    }
    return (
        <div>
            <section className="breadcrumb">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 bread-crumb">
                            <Link to="/">Home</Link><span>&gt;</span>About
                        </div>
                    </div>
                </div>
                <hr />
            </section>
            <section className="contentContainer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="aboutThumb imageThumbLeft">
                                <img src={"/frontend/images/about-thumb.jpg"} className="imgResponsive" />
                            </div>
                            <h2>About DirtMap</h2>
                            {/* <p>This is Photoshop's version  of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean , lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non  mauris vitae erat.</p>
                            <p>Consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit. Sed ut imperdiet nisi. Proin condimentum fermentum nunc. Etiam pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque. Suspendisse in orci enim.</p> */}
                            <p dangerouslySetInnerHTML={{ __html: page.description }}></p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="contentContainer highlightedBox">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h2>Standard Content &amp; Listing</h2>
                            <p>This is Photoshop's version  of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean , lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non  mauris vitae erat. Consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra.</p>
                            <ul className="listing01">
                                <li>Proin gravida nibh vel velit auctor aliquet rem quis bibendum auctor.</li>
                                <li>Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit. </li>
                                <li>Nam nec tellus a odio tincidunt auctor a ornare odio.</li>
                                <li>Consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <section className="contentContainer text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 col-md-12 m-auto">
                            <h2>Contact DirtMap Support Team</h2>
                            <p className="paddingLR80">This is Photoshop's version  of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean , lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. </p>
                            <Link className="button customButton01" to="/contact"> Contact  us</Link>
                        </div>
                    </div>
                </div>
            </section>
            {loader}
        </div>
    )
}

export default About;